import React from 'react'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Consulta Ventas' }]

const tableHeaderRows = [
  {
    label: 'FECHA',
    width: 85,
    align: 'center',
    filter: {
      type: 'date',
      name: 'fecha'
    }
  },
  { label: 'TIPO', width: 90, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serDoc'
    }
  },
  {
    label: 'NUM DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numDoc'
    }
  },
  {
    label: 'RUC',
    width: 100,
    align: 'center',
    filter: {
      type: 'text',
      name: 'ruc'
    }
  },
  {
    label: 'RAZÓN SOCIAL',
    align: 'center',
    filter: {
      type: 'text',
      name: 'razSoc'
    }
  },
  {
    label: '',
    width: 30,
    align: 'center'
  }
]

const ListaVentasPage = ({ history }) => {
  const tablaRef = React.useRef(null)

  const [mostrarConsultaOtroAnioModal, setMostrarConsultaOtroAnioModal] = React.useState(false)

  const clickConsultaOtroAnio = React.useCallback(() => {
    setMostrarConsultaOtroAnioModal(true)
  }, [])

  const clickVerHandle = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.CONSULTAVENTAS_VER_DETALLES}/${_id}`)
    },
    [history]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Consulta Ventas'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Consulta Otro Año', onClick: clickConsultaOtroAnio }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useFilters={true}
            useNest={true}
            url='/facturaciones/consulta-ventas'
            headRows={tableHeaderRows}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
                <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='ver' handleClose={handleClose} onClick={e => clickVerHandle({ _id: row._id })}>
                        Ver Detalles
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarConsultaOtroAnioModal && (
        <Modals.ConsultaOtroAnioModal show={mostrarConsultaOtroAnioModal} handleClose={() => setMostrarConsultaOtroAnioModal(false)} />
      )}
    </>
  )
}

export default ListaVentasPage
